<template>
  <div id="study-activity-activityId">
    <b-row class="p-20">
      <b-col cols="15" class="p-0">
        <h6>
          <span class="noOfFormsText">Order Activities</span>
        </h6>
      </b-col>
    </b-row>
    <template>
      <table class="create-edit-packet-page__order-table">
        <thead>
          <tr>
            <th class="p-0" width="5%"></th>
            <th class="p-0" width="25%">Name</th>
            <th class="p-0" width="15%">Type</th>
            <th class="p-0" width="25%">scheduled</th>
            <th class="p-0" width="12%">Steps</th>
            <th class="p-0" width="18%">Last Modified</th>
          </tr>
        </thead>
        <draggable v-model="participantActivities" @start="drag = true" tag="tbody" handle=".handle" class="pl-10">
          <tr v-for="(form, index) in participantActivities" :key="index">
            <td class="pl-10 drag-icon-container">
              <img src="static/img/activity-configurator/drag-icon.png" class="Vector mt-5 handle" />
            </td>
            <td class="form-name ">
              <span @click="showActivityVersions()" class="form-name ">
                {{ $sanitize(form.surveyTitle) }}
              </span>
            </td>
            <td class="activity_type mt-7 p-0">
              <span>{{ form.surveyType | activityTypeName }}</span>
            </td>
            <td>
              <div class="p-0 schedulemilestone" v-if="form.milestonesList && form.milestonesList.length > 0">
                <span v-for="(milestone, index) in getSortedMilestoneList(form, 0, 3)" :key="index" :id="'form_' + form.surveyId + 'milestone_' + milestone.milestoneId">
                  {{ milestone.milestoneName }}
                  <span v-if="index + 1 < form.milestonesList.length">
                    ,
                  </span>
                  <b-tooltip :target="'form_' + form.surveyId + 'milestone_' + milestone.milestoneId">
                    <div v-for="(listOfMilestones, index) in studyData.milestonesList" :key="index">
                      <span v-if="milestone.milestoneId === listOfMilestones.milestoneId">Milestone {{ index + 1 }}</span>
                    </div>
                    <div>
                      <span>Day {{ milestone.milestoneDay }}</span>
                    </div>
                  </b-tooltip>
                </span>
                <button v-if="form.milestonesList && form.milestonesList.length > 3" variant="primary" class="btn show_milestones_plus_btn" size="lg" :id="`selected-${form.surveyId}-milestone`" tabindex="0">
                  +
                </button>
                <b-popover :target="`selected-${form.surveyId}-milestone`" triggers="click blur" placement="right" container="study-activity-activityId">
                  <div class="create-edit-packet-table__language-pop-over-container">
                    <ul class="create-edit-packet-table__languages-list">
                      <li class="create-edit-packet-table__languages-list-item" v-for="(milestone, index) in getSortedMilestoneList(form, 3, form.length)" :key="index" :id="'form_' + form.surveyId + 'milestone_' + milestone.milestoneId">
                        {{ milestone.milestoneName }}
                      </li>
                    </ul>
                  </div>
                </b-popover>
              </div>
              <button v-else variant="primary" class="schedule-btn" size="lg" @click="scheduleActivity(form)">
                Schedule
              </button>
            </td>
            <td class="p-0">{{ $sanitize(form.questionCount) }}</td>
            <td class="p-0 date-text">{{ getLastModifiedTime(form) }}</td>
          </tr>
        </draggable>
      </table>
      <div class="action-btns p-20 text-right">
        <span @click="goBackToActivitiesList" class="mr-20 cursor-pointer">Cancel</span>
        <button variant="primary" class="btn btn-primary buttons" @click="saveActivityOrderSequence()">
          <span>Save Order</span>
        </button>
      </div>
    </template>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import toastr from "toastr";
import moment from "moment";
import _ from "lodash";

export default {
  name: "ActivitiesOrder",
  data() {
    return {
      participantActivities: [],
      autoSaveElementTimeout: process.env.VUE_APP_AUTO_SAVE_ELEMENT_LIB_TIMEOUT,
      cancelOrderActivities: false
    };
  },
  props: {
    studyId: {
      type: String
    },
    studyData: {
      type: Object
    }
  },
  components: {
    draggable
  },
  mounted() {
    this.getParticipantFacingActivities();
    this.startAutoSave();
  },
  filters: {
    activityTypeName(value) {
      if (value == "PRO (Patient Reported Outcome)") {
        return "PRO";
      } else {
        return value;
      }
    }
  },
  methods: {
    getParticipantFacingActivities() {
      this.$api.getParticipantStudyActivities(this.studyId).then(response => {
        this.participantActivities = response.data;

        this.participantActivities.forEach((activity, index) => {
          activity.sequence = index;
        });
      });
    },
    getSortedMilestoneList(form, start, end) {
      const formClone = _.cloneDeep(form);
      formClone.milestonesList.sort((a, b) => Number(a.sortOrder) - Number(b.sortOrder));
      return formClone.milestonesList.slice(start, end);
    },
    goBackToActivitiesList() {
      this.cancelOrderActivities = true;
      this.$emit("viewScheduleActivities");
    },
    saveActivityOrderSequence(autoSave = false) {
      this.$api
        .saveActivityOrder(this.studyId, this.participantActivities)
        .then(() => {
          if (!autoSave) {
            toastr.success("Activity Order has been Saved");
          }
        })
        .catch(() => {
          if (!autoSave) {
            toastr.error("Something went Wrong");
          }
        });
      this.goBackToActivitiesList();
    },
    getLastModifiedTime(form) {
      if (form.modifiedTime) {
        const modifiedTimeMoment = moment(form.modifiedTime, "YYYY-MM-DD HH:mm:ss");
        return modifiedTimeMoment.format("D MMM YYYY");
      }
      return "";
    },
    startAutoSave() {
      this.autoSaveTimer = setInterval(() => {
        this.saveActivityOrderSequence(true);
      }, this.autoSaveElementTimeout);
    },
    stopAutoSave() {
      clearInterval(this.autoSaveTimer);
    }
  },
  beforeDestroy() {
    if (!this.cancelOrderActivities) {
      this.saveActivityOrderSequence(true);
    }
    this.stopAutoSave();
  },
  watch: {
    participantActivities: {
      deep: true,
      handler() {
        this.participantActivities.forEach((activity, index) => {
          activity.sequence = index + 1;
        });
      }
    }
  }
};
</script>
<style scoped lang="scss">
.schedulemilestone span:nth-child(3) span {
  display: none;
}

.create-edit-packet-page__order-table td a {
  position: relative;
  top: 5px;
}

.show_milestones_plus_btn {
  width: 26px;
  height: 24px;
  border-radius: 4px;
  border: 1px solid #d3dee3;
  background-color: #fff;
  color: #00f;
  padding: 0;
  line-height: 20px;
}

.cursor-pointer {
  cursor: pointer;
}

.tableBg2 {
  background-color: #ffffff !important;
  padding: 24px 20px 0px 20px !important;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.06);
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  border-top: none;
  width: 100%;
  border-left: 1px solid #d3dfe4;
  border-right: 1px solid #d3dfe4;
}

.noOfFormsText {
  width: 172px;
  height: 24px;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  color: #000000;
}

.form-name {
  width: 300px;
  height: 24px;
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.71;
  letter-spacing: normal;
  color: #4c8ce4 !important;
}

.create-edit-packet-page {
  padding: 20px !important;

  &__order-table {
    tr {
      height: 41px;
      border-bottom: 1px solid #d3dfe4;
    }
  }

  &__add-forms-table {
    tr {
      height: 41px;
      border-bottom: 1px solid #d3dfe4;
    }

    input[type="checkbox"] {
      // display: none;
      height: 21px;
      width: 21px;
    }
  }

  &__order-table,
  &__add-forms-table {
    th {
      font-family: "RobotoRegular";
      font-size: 11px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 2.18;
      letter-spacing: normal;
      color: #b0bac9;
    }

    td {
      font-size: 12px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 2;
      letter-spacing: normal;
      color: #000000;
    }

    .activity_type {
      font-size: 12px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 2;

      letter-spacing: normal;
      color: #000000;
    }
  }
}

.Vector {
  width: 21px;
  height: 15px;
  vertical-align: top;
}

.schedule-btn {
  background-color: white;
  border-radius: 3px;
  border: solid 1px #4c8ce4;
  height: 25px;
  cursor: pointer;
  font-size: 12px;
  color: #4c8ce4;
  padding: 0px 10px;
}

.buttons {
  width: 100px;
  height: 33px;
  font-size: 13px;
  border-radius: 5px;
}
</style>
